import React, { useState, useEffect } from 'react';
import { setAnalyticsConsent, hasAnalyticsConsent } from '../lib/analytics';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if consent has been given
    const hasConsent = hasAnalyticsConsent();
    // Only show banner if no consent has been recorded
    if (typeof hasConsent === 'undefined') {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent(true);
    setShow(false);
  };

  const handleDecline = () => {
    setAnalyticsConsent(false);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 p-4 z-50">
      <div className="container mx-auto max-w-4xl flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-600">
          <p>
            We use cookies to analyze site traffic and improve your experience.
            Your privacy is important to us. You can change your preferences anytime.
          </p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={handleDecline}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="px-4 py-2 text-sm font-medium text-primary bg-secondary hover:bg-secondary-light rounded-lg transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}